const USER_FIRST_NAME = "USER_FIRST_NAME";
const USER_LAST_NAME = "USER_LAST_NAME";
const USER_EMAIL = "USER_EMAIL";
const USER_PASSWORD = "USER_PASSWORD";
const USER_PASSWORD_CONFIRM = "USER_PASSWORD_CONFIRM";
const AUTH_TOKEN = "AUTH_TOKEN";

export {
  USER_FIRST_NAME,
  USER_LAST_NAME,
  USER_EMAIL,
  USER_PASSWORD,
  USER_PASSWORD_CONFIRM,
  AUTH_TOKEN
};
